import BaseApi from '../base/base'
import Category from '../../models/category'

export default class CategoryApi extends BaseApi {
  constructor() {
    super()
    this.path = '/lists'
  }

  async index(params = {}) {
    this.path = '/lists'
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new Category(element)
    })
  }

  async my(params = {}) {
    this.path = '/lists/my'
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new Category(element)
    })
  }
}
